module.exports = __webpack_public_path__ + "static/media/TermsAndConditions.841aa475.pdf";